export const UserPermissionService = Symbol.for('UserPermissionService');
